import { isBlockRangeSelection } from '@gitbook/slate';

/**
 * Check if the node is the only selected node.
 * True is selection is collapsed and cursor is in node,
 * A void node is closely wrapped by an expanded selection
 * or the node is the only selected node in an expanded selection.
 */
export function isOnlySelectedNode(selection, node, parent) {
    if (isBlockRangeSelection(selection)) {
        return selection.isCollapsed;
    }
    return (
        selection.hasOnlyNodeSelected(node) ||
        selection.hasOnlyNodeSelectedExpanded(node) ||
        selection.isOnlyNodeWrapped(node, parent)
    );
}
